import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icp-wrapper" }
const _hoisted_2 = { href: "https://beian.miit.gov.cn/" }
const _hoisted_3 = { class: "text" }

import DisclaimerPop from "./DisclaimerPop.vue";

import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'IcpComp',
  setup(__props) {

const appName = ref<string>(APP_NAME);
const company = ref<string>(APP_CONFIG_COMPANY_NAME);
const icp = ref<string>(APP_CONFIG_BEI_AN_CODE);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text" }, "ICP备案/许可证号：", -1)),
    _createElementVNode("a", _hoisted_2, _toDisplayString(icp.value), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(appName.value) + "-" + _toDisplayString(company.value), 1),
    _createVNode(DisclaimerPop, { company: company.value }, null, 8, ["company"])
  ]))
}
}

})